import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  Typography,
  Box,
} from "@mui/material";
import { getSizeLabel } from "../../utils/getSizeLabel";

const GroupedSizeDropdown = ({ sizes, selectedSizeId, onChange }) => {
  // Group sizes by tierCount
  const grouped = sizes.reduce((acc, size) => {
    const tier = size.tierCount || 1;
    if (!acc[tier]) acc[tier] = [];
    acc[tier].push(size);
    return acc;
  }, {});

  const tierOrder = Object.keys(grouped)
    .map(Number)
    .sort((a, b) => a - b);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 600, mb: 1, color: "#1A1A1A" }}>
        Size
      </Typography>

      <FormControl fullWidth>
        <Select
          value={selectedSizeId}
          onChange={onChange}
          displayEmpty
          MenuProps={{
            disablePortal: true,
            PaperProps: {
              sx: {
                zIndex: 1200, // Ensure this is below your sticky button zIndex
              },
            },
          }}
          renderValue={(selectedId) => {
            if (!selectedId) return "Select";
            const selectedSize = sizes.find((s) => s._id === selectedId);
            return getSizeLabel(selectedSize);
          }}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            border: "1px solid #ccc",
            fontWeight: 500,
            color: selectedSizeId ? "black" : "#999",
            "& .MuiSelect-icon": {
              color: "#515151",
            },
          }}>
          {tierOrder.map((tier) => [
            <ListSubheader
              key={`header-${tier}`}
              disableSticky
              sx={{
                fontWeight: "bold",
                fontSize: "1rem",
                color: "#1A1A1A",
                backgroundColor: "transparent",
                px: 2,
              }}>
              {`${tier} Tier Options`}
            </ListSubheader>,
            ...grouped[tier].map((size) => (
              <MenuItem
                key={size._id}
                value={size._id}
                sx={{
                  px: 3,
                }}>
                <Typography variant="body2">
                  {size.displayName}
                  {size.servings && ` (serves max ${size.servings} people)`}
                  {size.price > 0 && ` +$${size.price.toFixed(2)}`}
                </Typography>
              </MenuItem>
            )),
          ])}
        </Select>
      </FormControl>
    </Box>
  );
};

export default GroupedSizeDropdown;
